import { createContext, useContext } from 'react';
import { Persistor } from 'redux-persist';

// @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'null' is not assignable to param... Remove this comment to see the full error message
const persistorContext = createContext<Persistor>(null);

export const usePersistor = () => useContext(persistorContext);

export default persistorContext;
